import React from 'react';
import { describe } from '@elliemae/ds-props-helpers';
import { DSButton } from '../SharedButtonBaseline/index.js';
import type { DSButtonV2T } from './react-desc-prop-types.js';
import { DSButtonV2PropTypes } from './react-desc-prop-types.js';
import { DSButtonV2Name } from './DSButtonV2Definitions.js';

const DSButtonV2: React.ComponentType<DSButtonV2T.Props> = ({ children, ...otherProps }) => (
  <DSButton {...otherProps} isV3={false}>
    {children}
  </DSButton>
);

DSButtonV2.displayName = DSButtonV2Name;
const DSButtonV2WithSchema = describe(DSButtonV2);
DSButtonV2WithSchema.propTypes = DSButtonV2PropTypes;

export { DSButtonV2, DSButtonV2WithSchema };
